import React, { useState, useContext } from "react";
import {
    NavLink,
    Button,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";
import {
    RiArrowDownWideLine,
    RiUserAddLine,
    RiUserFill,
    RiUserLine,
    RiFolderMusicLine,
    RiShutDownLine,
    RiCloseLine, RiSettings2Line, RiMenuLine
} from "react-icons/ri";
import { AuthContext } from "../helpers/AuthContext";
import InstallAppButton from "../general/InstallAppButton";

function Navigation() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const { isLoggedIn, customer, logout } = useContext(AuthContext);
    const user = customer?.user;
    const userFullName = [user?.firstName, user?.lastName].filter(Boolean).join(" ");

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    return (
        <div className="fixed-top bg-primary twb-main-navigation">
            <div className="twb-main-navigation-bar container">
                <a href="/" className="twb-main-navigation-brand">
                    <img
                        src={require("../../assets/images/worship-bible-logo-6.png")}
                        alt="The Worship Bible"
                    />
                    <span>The Worship Bible</span>
                </a>

                <nav className="twb-main-navigation-desktop" aria-label="Primary navigation">
                    {!isLoggedIn && (
                        <>
                            <NavLink href="/benefits" className="text-white">
                                Benefits
                            </NavLink>
                            <NavLink href="/plans-and-pricing" className="text-white">
                                Plans & Pricing
                            </NavLink>
                        </>
                    )}

                    <NavLink href="/help" className="text-white">
                        Help
                    </NavLink>

                    {!isLoggedIn && (
                        <>
                            <Button color="white" href="/register/choose-your-plan">
                                <RiUserAddLine className="me-1" /> Register
                            </Button>
                            <NavLink href="/sign-in" className="text-white">
                                <RiUserFill className="me-1" /> Sign in
                            </NavLink>
                        </>
                    )}

                    {isLoggedIn && (
                        <UncontrolledDropdown>
                            <DropdownToggle nav className="text-white d-flex align-items-center">
                                <RiUserFill className="me-1" />&nbsp;
                                {customer?.user?.firstName || "Account"}
                                <RiArrowDownWideLine className="ms-1" />
                            </DropdownToggle>

                            <DropdownMenu end className="twb-dropdown" container="body">
                                <div className="twb-dropdown-header">
                                    <div className="twb-dropdown-header-name">
                                        {userFullName || "Your account"}
                                    </div>
                                    {user?.email && (
                                        <div className="twb-dropdown-header-email">{user.email}</div>
                                    )}
                                </div>
                                <DropdownItem divider />

                                <NavLink href="/your-profile" className="twb-dropdown-item">
                                    <div className="twb-dropdown-icon"><RiUserLine size={18}/></div>
                                    <div className="twb-dropdown-text">
                                        <div className="twb-dropdown-title text-primary">Your Profile</div>
                                        <div className="twb-dropdown-subtitle">Manage your account</div>
                                    </div>
                                </NavLink>

                                <NavLink href="/your-profile/saved-song-flows" className="twb-dropdown-item">
                                    <div className="twb-dropdown-icon"><RiFolderMusicLine size={18}/></div>
                                    <div className="twb-dropdown-text">
                                        <div className="twb-dropdown-title text-primary">Saved Song-flows</div>
                                        <div className="twb-dropdown-subtitle">View and manage your plans</div>
                                    </div>
                                </NavLink>

                                <NavLink href="/next-steps" className="twb-dropdown-item">
                                    <div className="twb-dropdown-icon"><RiFolderMusicLine size={18}/></div>
                                    <div className="twb-dropdown-text">
                                        <div className="twb-dropdown-title text-primary">Next steps</div>
                                        <div className="twb-dropdown-subtitle">
                                            Create your next song-flow based on your recent activity
                                        </div>
                                    </div>
                                </NavLink>

                                {customer?.user?.isAdmin && (
                                    <NavLink href="/admin" className="twb-dropdown-item">
                                        <div className="twb-dropdown-icon"><RiSettings2Line size={18}/></div>
                                        <div className="twb-dropdown-text">
                                            <div className="twb-dropdown-title text-primary">Administration</div>
                                            <div className="twb-dropdown-subtitle">Manage site content</div>
                                        </div>
                                    </NavLink>
                                )}

                                <div className="px-3 py-2">
                                    <InstallAppButton/>
                                </div>

                                <NavLink href="/sign-out" onClick={logout} className="twb-dropdown-item">
                                    <div className="twb-dropdown-icon"><RiShutDownLine size={18}/></div>
                                    <div className="twb-dropdown-text">
                                        <div className="twb-dropdown-title text-primary">Sign out</div>
                                        <div className="twb-dropdown-subtitle">End your session</div>
                                    </div>
                                </NavLink>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}
                </nav>

                <button
                    className="twb-main-navigation-toggle"
                    type="button"
                    aria-label={mobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
                    aria-expanded={mobileMenuOpen}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    {mobileMenuOpen ? <RiCloseLine size={30} /> : <RiMenuLine size={32} />}
                </button>
            </div>

            {mobileMenuOpen && (
                <nav className="twb-main-navigation-mobile" aria-label="Mobile navigation">
                    {!isLoggedIn && (
                        <>
                            <a href="/benefits" onClick={closeMobileMenu}>Benefits</a>
                            <a href="/plans-and-pricing" onClick={closeMobileMenu}>Plans & Pricing</a>
                        </>
                    )}

                    <a href="/help" onClick={closeMobileMenu}>Help</a>

                    {!isLoggedIn && (
                        <>
                            <a href="/register/choose-your-plan" onClick={closeMobileMenu}>
                                <RiUserAddLine /> Register
                            </a>
                            <a href="/sign-in" onClick={closeMobileMenu}>
                                <RiUserFill /> Sign in
                            </a>
                        </>
                    )}

                    {isLoggedIn && (
                        <>
                            <a href="/your-profile" onClick={closeMobileMenu}>
                                <RiUserLine /> Your Profile
                            </a>
                            <a href="/your-profile/saved-song-flows" onClick={closeMobileMenu}>
                                <RiFolderMusicLine /> Saved Song-flows
                            </a>
                            <a href="/next-steps" onClick={closeMobileMenu}>
                                <RiFolderMusicLine /> Next steps
                            </a>
                            {customer?.user?.isAdmin && (
                                <a href="/admin" onClick={closeMobileMenu}>
                                    <RiSettings2Line /> Administration
                                </a>
                            )}
                            <div className="twb-main-navigation-mobile-install">
                                <InstallAppButton/>
                            </div>
                            <a href="/sign-out" onClick={logout}>
                                <RiShutDownLine /> Sign out
                            </a>
                        </>
                    )}
                </nav>
            )}
        </div>
    );
}

export default Navigation;
